import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MinusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space, Tag } from "antd";
import { EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { Trans } from "@devowl-wp/react-frontend";
import { useTranslation } from "../../../../../../others/i18n.js";
import { spacing } from "../../../../../../styles/spacing.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { WhenOnOfTip } from "../../fields/when-one-of/when-one-of-tip.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateShouldUncheckContentBlockerCheckboxWhenOneOfList() {
    const { t } = useTranslation();
    const dependencyFieldName = ServiceTemplateField.ShouldUncheckContentBlockerCheckbox;
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.ShouldUncheckContentBlockerCheckboxWhenOneOf,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || prev.shouldUncheckContentBlockerCheckbox !== next.shouldUncheckContentBlockerCheckbox,
            noStyle: true,
            children: ({ getFieldValue })=>{
                const isUncheckContentBlockerCheckbox = getFieldValue([
                    dependencyFieldName
                ]);
                return !isUncheckContentBlockerCheckbox && /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(ServiceTemplateField.ShouldUncheckContentBlockerCheckboxWhenOneOf, t),
                    dependencies: [
                        dependencyFieldName
                    ],
                    children: ({ getFieldValue })=>{
                        const extended = getFieldValue(TemplateMetaDataField.Extends);
                        return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                            extendsFieldName: ServiceTemplateField.ShouldUncheckContentBlockerCheckboxWhenOneOf,
                            disableStrategies: getDisableStrategies(true),
                            onKeepContent: extended && extended[ServiceTemplateField.ShouldUncheckContentBlockerCheckboxWhenOneOf] && /*#__PURE__*/ _jsx(Space, {
                                size: [
                                    8,
                                    8
                                ],
                                wrap: true,
                                children: extended[ServiceTemplateField.ShouldUncheckContentBlockerCheckboxWhenOneOf]?.map((entry, index)=>/*#__PURE__*/ _jsx(Tag, {
                                        color: "grey",
                                        children: entry
                                    }, `extends--entry-${ServiceTemplateField.ShouldUncheckContentBlockerCheckboxWhenOneOf}-${index}}`))
                            }),
                            children: /*#__PURE__*/ _jsx(Form.List, {
                                name: ServiceTemplateField.ShouldUncheckContentBlockerCheckboxWhenOneOf,
                                children: (fields, { add, remove })=>/*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Item, {
                                                extra: /*#__PURE__*/ _jsxs(Trans, {
                                                    children: [
                                                        "When at least one of the following conditions is true, the recommended content blocker will",
                                                        " ",
                                                        /*#__PURE__*/ _jsx("b", {
                                                            children: "not"
                                                        }),
                                                        " be created by default."
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ _jsxs(Space, {
                                                    size: "small",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            type: "default",
                                                            onClick: ()=>add(),
                                                            style: {
                                                                maxWidth: "10rem"
                                                            },
                                                            children: t("Add")
                                                        }),
                                                        /*#__PURE__*/ _jsx(WhenOnOfTip, {})
                                                    ]
                                                })
                                            }),
                                            fields.map((field, index)=>/*#__PURE__*/ _jsxs("span", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Item, {
                                                            ...field,
                                                            validateTrigger: [
                                                                "onChange",
                                                                "onBlur"
                                                            ],
                                                            noStyle: true,
                                                            children: /*#__PURE__*/ _jsx(Input, {
                                                                placeholder: "is-wordpress-plugin-or-theme-active:some-slug",
                                                                style: {
                                                                    width: "90%"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(MinusCircleOutlined, {
                                                            style: {
                                                                marginLeft: spacing.layout.content.padding
                                                            },
                                                            className: "dynamic-delete-button",
                                                            onClick: ()=>remove(field.name)
                                                        })
                                                    ]
                                                }, `recommended-uncheck-item-${index}`))
                                        ]
                                    })
                            })
                        });
                    }
                });
            }
        })
    });
}
export { FormFieldServiceTemplateShouldUncheckContentBlockerCheckboxWhenOneOfList };
